import WxDataDialog from './wxDataDialog.vue';
import { WxIDataDialog } from './WxIDataDialog';

export { WxDataDialog };
export { WxIDataDialog };
export default WxDataDialog;
